import { TextCodes } from '@api/types/translation/TextCodes';

import { t } from '@translations';

import { Button, AddRequestInfoModal } from '@components';
import { setModalState } from '@store/modal/modal.slice';
import { useAppDispatch } from '@hooks';

export const ProductRequestInfo = () => {
  const dispatch = useAppDispatch();
  const modalOrderId = 'product-request-info-modal';
  const openMobileModal = () => dispatch(setModalState({ id: modalOrderId, isVisible: true }));

  return (
    <>
      <Button
        variant='text'
        sx={{ background: '#fff', color: '#000', height: '44px' }}
        onClick={openMobileModal}
      >
        {t(TextCodes.Product.Details.RequestInformation)}
      </Button>
      <AddRequestInfoModal modalId={modalOrderId} />
    </>
  );
};
